import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17414118"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "an-field" }
const _hoisted_2 = {
  class: "an-label",
  for: "assignee"
}
const _hoisted_3 = { class: "an-select-wrap" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "an-hint"
}
const _hoisted_7 = {
  key: 0,
  class: "an-file-list"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "an-file-dot" }, null, -1))
const _hoisted_9 = { class: "an-file-name" }
const _hoisted_10 = { class: "an-file-status" }
const _hoisted_11 = ["aria-label", "onClick"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

import { ElMessage } from 'element-plus';
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

import CustomModal from '@/components/CustomModal.vue';
import FileDropzone from '@/components/FileDropzone.vue';
import config from '@/config';
import { canAssignAnalyst } from '@/helpers/permission';
import { Litigation } from '@/Litigation/litigation.entity';
import { useSimilarAnalysesStore } from '@/stores/similar-analyses.store';
import { useUploadDecisionStore } from '@/stores/upload-decision.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddDecisionModal',
  props: {
    litigation: {}
  },
  emits: ["close", "success"],
  setup(__props: any, { emit }) {

const props = __props;




const { t } = useI18n();
const uploadStore = useUploadDecisionStore();
const similarAnalysesStore = useSimilarAnalysesStore();

const { assignableMembers, selectedAssigneeId, files, submitting, hasReadyFiles, hasFailed, locked } =
    storeToRefs(uploadStore);

// Drives the disabled state only; the backend re-checks the capability on write.
const canAssign = canAssignAnalyst(props.litigation);

onMounted(async () => {
    uploadStore.reset();

    if (!props.litigation.litigationId) return;

    try {
        await uploadStore.loadAssignableMembers(props.litigation.litigationId);
    } catch {
        // Non-blocking: the dropdown still offers the current user, so self-upload keeps working.
        ElMessage.error(t('addDecision.loadAnalystsError'));
    }
});

const onSelect = (accepted: File[], rejected: number): void => {
    uploadStore.stageFiles(accepted);

    if (rejected > 0) {
        ElMessage.warning(t('addDecision.acceptedTypesHint', { types: config.acceptedExtensions.join(', ') }));
    }
};

const removeFile = (id: number): void => {
    uploadStore.removeFile(id);
};

// Close the modal, then run the duplicate-decision check for everything created this session.
// Deferring until close keeps the DuplicateDecisionModal from stacking on top of this one.
const closeAndCheck = (): void => {
    emit('close');
    if (uploadStore.hasCreated) {
        void similarAnalysesStore.checkUploads(uploadStore.createdBatch);
    }
};

const submit = async (): Promise<void> => {
    const { success, failed } = await uploadStore.uploadReady(props.litigation.name);

    if (success === 0 && failed === 0) return;
    if (success > 0) emit('success');

    if (failed === 0) {
        ElMessage.success(t('addDecision.allUploaded', { count: success }));
        closeAndCheck();
    } else if (success === 0) {
        ElMessage.error(t('addDecision.allFailed'));
    } else {
        ElMessage.warning(t('addDecision.partialUploaded', { success, failed }));
    }
};

const retryFailed = (): void => {
    uploadStore.requeueFailed();
    void submit();
};

const onClose = (): void => {
    if (submitting.value) return;
    closeAndCheck();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomModal, {
    width: "560px",
    "min-width": "560px",
    onClose: onClose
  }, {
    "modal-header": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('addDecision.title')), 1)
    ]),
    "modal-footer": _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "button is-radius-small has-text-weight-semibold",
        disabled: _unref(submitting),
        onClick: onClose
      }, _toDisplayString(_unref(t)('addDecision.cancel')), 9, _hoisted_12),
      (_unref(hasFailed) && !_unref(submitting))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "button is-radius-small has-text-weight-semibold",
            onClick: retryFailed
          }, _toDisplayString(_unref(t)('addDecision.retryFailed')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "button is-primary is-radius-small has-text-weight-semibold",
        disabled: !_unref(hasReadyFiles) || _unref(submitting),
        onClick: submit
      }, _toDisplayString(_unref(submitting) ? _unref(t)('addDecision.uploading') : _unref(t)('addDecision.submit')), 9, _hoisted_13)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(t)('addDecision.assignTo')), 1),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            id: "assignee",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedAssigneeId) ? (selectedAssigneeId).value = $event : null)),
            class: "an-select",
            disabled: !_unref(canAssign) || _unref(locked)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(assignableMembers), (member) => {
              return (_openBlock(), _createElementBlock("option", {
                key: member.memberId,
                value: member.memberId
              }, _toDisplayString(member.firstName) + " " + _toDisplayString(member.lastName), 9, _hoisted_5))
            }), 128))
          ], 8, _hoisted_4), [
            [_vModelSelect, _unref(selectedAssigneeId)]
          ])
        ]),
        (!_unref(canAssign))
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(t)('addDecision.assignToDisabledHint')), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(FileDropzone, {
        accept: _unref(config).acceptedExtensions,
        disabled: _unref(submitting),
        onSelect: onSelect
      }, null, 8, ["accept", "disabled"]),
      (_unref(files).length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(files), (staged) => {
              return (_openBlock(), _createElementBlock("li", {
                key: staged.id,
                class: _normalizeClass(["an-file-row", `is-${staged.status}`])
              }, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(staged.file.name), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)(`addDecision.status.${staged.status}`)), 1),
                (!_unref(submitting) && staged.status !== 'success')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "an-file-remove",
                      "aria-label": _unref(t)('addDecision.remove'),
                      onClick: ($event: any) => (removeFile(staged.id))
                    }, " × ", 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})